import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Navigation from "./components/Navigation";
import { About } from "./components/About";
import Gallery from "./components/Gallery";
import { AppFooter } from "./components/AppFooter";
import Contact from "./components/Contact";
import { CanvasArtworkPage } from "./components/ArtWork/CanvasArtworkPage";
import { AiArtworkPage } from "./components/ArtWork/AiArtworkPage";
import {
  DigitalArtworkPage,
  LegacyArtworkRedirect,
} from "./components/ArtWork/DigitalArtworkPage";
import { ScrollToTop } from "./components/ScrollToTop";

function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <Router>
        <ScrollToTop />
        <Navigation />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/originals" element={<Navigate to="/gallery?tab=canvas" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/commission" element={<Navigate to="/contact#commission" replace />} />
            <Route path="/art/canvas/:id" element={<CanvasArtworkPage />} />
            <Route path="/art/ai/:id" element={<AiArtworkPage />} />
            <Route path="/art/digital/:id" element={<DigitalArtworkPage />} />
            <Route path="/artwork/:id" element={<LegacyArtworkRedirect />} />
          </Routes>
        </main>
        <AppFooter />
      </Router>
    </div>
  );
}

export default App;
